import React from 'react';
import styled from 'styled-components';
import { Card, Rate, Typography } from 'antd';
import { colors } from '../../util/colors';
import brigitteImg from '../../assets/brigitte.png';
import sabrinaImg from '../../assets/sabrina.png';
import karinImg from '../../assets/karin.png';
import anetteImg from '../../assets/anette.png';
import gertraudImg from '../../assets/gertraud.png';
import monikaImg from '../../assets/monika.png';
import inesImg from '../../assets/ines.png';
import barbaraImg from '../../assets/barbara.png';
import christianImg from '../../assets/christian.png';
import walterImg from '../../assets/walter.png';
import jensImg from '../../assets/jens.png';
import hansImg from '../../assets/hans.png';

const { Text, Paragraph } = Typography;

interface Testimonial {
    name: string;
    location: string;
    rating: number;
    text: string;
    image: string;
    date: string;
}

interface TestimonialsProps {}

export const Testimonials: React.FC<TestimonialsProps> = () => {
    const testimonials: Testimonial[] = [
        {
            name: "Brigitte A.",
            location: "Berlin",
            rating: 5,
            text: "Ich habe 80€ in den Jahrestarif von silver+ investiert und fange jetzt einen neuen Job an, bei dem ich 2000€ verdiene. Es hat sich mehr als gelohnt. Die Anschreiben-hilfe war super.",
            image: brigitteImg,
            date: "2. Oktober 2025"
        },
        {
            name: "Sabrina U.",
            location: "München",
            rating: 5,
            text: "Wegen der Aktivrente wollen jetzt viele Rentner weiterarbeiten. Mit Silver+ und der KI Unterstützung habe ich jetzt einen unfairen Vorteil - genial!",
            image: sabrinaImg,
            date: "3. September 2025"
        },
        {
            name: "Christian E.",
            location: "Nürnberg",
            rating: 5,
            text: "silver+ hat mir geholfen, wieder Struktur in meinen Alltag zu bringen. Der Trainer für Bewerbungsgespräche war Gold wert, denn ich war richtig gut vorbereitet.",
            image: christianImg,
            date: "13. September 2025"
        },
        {
            name: "Walter O.",
            location: "Stuttgart",
            rating: 5,
            text: "Ich war skeptisch, aber der Jobcoach von Silver+ hat mir Mut gemacht. Wir haben meine Stärken besprochen und einen Plan erstellt. Jetzt fühle ich mich wieder sicher.",
            image: walterImg,
            date: "25. September 2025"
        },
        {
            name: "Jens K.",
            location: "Mannheim",
            rating: 5,
            text: "Ich bin 66 und suche nach einem neuen Job. Früher hat mich eine Bewerbung eine Stunde Zeit gekostet, mit dem Anschreiben Generator klappts in 5 Minuten!",
            image: jensImg,
            date: "07. Oktober 2025"
        },
        {
            name: "Karin U.",
            location: "Köln",
            rating: 5,
            text: "Silver+ ist einfach zu bedienen. Die KI-Jobsuche schlägt mir Jobs vor, die wirklich zu mir passen. Kein Stress, kein Papierkram – das gefällt mir.",
            image: karinImg,
            date: "19. Oktober 2025"
        },
        {
            name: "Anette F.",
            location: "Düsseldorf",
            rating: 5,
            text: "Ich dachte, niemand stellt mich mit 70 mehr ein. Aber Silver+ hat mich eines Besseren belehrt. Heute arbeite ich wieder als Erzieherin in Teilzeit.",
            image: anetteImg,
            date: "7. September 2025"
        },
        {
            name: "Gertraud W.",
            location: "Bonn",
            rating: 5,
            text: "Ich habe über Silver+ ein Vorstellungsgespräch bekommen – der Trainer für Bewerbungsgespräche hat mir geholfen, meine Nervosität in Griff zu kriegen.",
            image: gertraudImg,
            date: "12. September 2025"
        },
        {
            name: "Monika R.",
            location: "Frankfurt a.M.",
            rating: 5,
            text: "silver+ hat mir gezeigt, dass Erfahrung zählt. Der Jobcoach hat mir geholfen, meine lange Berufserfahrung richtig zu präsentieren. Jetzt traue ich mich wieder, mich zu bewerben.",
            image: monikaImg,
            date: "27. September 2025"
        },
        {
            name: "Hans-Joachim I.",
            location: "Leipzig",
            rating: 5,
            text: "Ich nutze Silver+ seit einem Monat. Noch kein Job, aber die Anschreiben-hilfe macht's mir leichter, mich zu bewerben. Ich bleibe dran!",
            image: hansImg,
            date: "12. Oktober 2025"
        },
        {
            name: "Ines H.",
            location: "Dresden",
            rating: 5,
            text: "silver+ hat mir echt geholfen. Die Ki Jobsuche zeigt mir nur das, was zu mir passt. kein blabla, sondern ehrliche angebote. gefällt mir!",
            image: inesImg,
            date: "26. Oktober 2025"
        },
        {
            name: "Barbara W.",
            location: "Hannover",
            rating: 5,
            text: "Ich bin 63 und arbeite jetzt wieder zwei Tage pro Woche im Büro. Mit silver plus habe ich in kurzer Zeit über 40 Bewerbungsschreiben generiert!",
            image: barbaraImg,
            date: "29. Oktober 2025"
        }
    ];

    return (
        <TestimonialsGrid>
            {testimonials.map((testimonial, index) => (
                <TestimonialCard key={index}>
                    <TestimonialHeader>
                        <TestimonialNameWrapper>
                            <ProfileImage
                                src={testimonial.image}
                                alt={testimonial.name}
                            />
                            <TestimonialInfo>
                                <TestimonialName>{testimonial.name}</TestimonialName>
                                <TestimonialLocation>{testimonial.location}</TestimonialLocation>
                            </TestimonialInfo>
                        </TestimonialNameWrapper>
                        <Rate disabled defaultValue={testimonial.rating} style={{ fontSize: '14px' }} />
                    </TestimonialHeader>
                    <TestimonialText>{testimonial.text}</TestimonialText>
                    <TestimonialDate>{testimonial.date}</TestimonialDate>
                </TestimonialCard>
            ))}
        </TestimonialsGrid>
    );
};

// Styled Components
const TestimonialsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    gap: 24px;
    margin-bottom: 32px;

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
        gap: 20px;
    }
`;

const TestimonialCard = styled(Card)`
    border-radius: 16px;
    border: none;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
    height: 100%;
    display: flex;
    flex-direction: column;
    background: white;

    .ant-card-body {
        padding: 0 16px;
        display: flex;
        flex-direction: column;
        gap: 16px;
        flex: 1;
    }
`;

const TestimonialHeader = styled.div`
    display: flex;
    gap: 8px;
    align-items: flex-start;
    flex-direction: column;
`;

const TestimonialNameWrapper = styled.div`
    display: flex;
    gap: 16px;
    align-items: center;
`;

const ProfileImage = styled.img`
    width: 40px;
    height: 40px;
    border-radius: 50%;
`;

const TestimonialInfo = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`;

const TestimonialName = styled(Text)`
    font-size: 1rem;
    font-weight: 600 !important;
    color: ${colors.text} !important;
`;

const TestimonialLocation = styled(Text)`
    font-size: 0.8rem !important;
    color: #999 !important;
`;

const TestimonialText = styled(Paragraph)`
    font-size: 0.9375rem !important;
    line-height: 1.6 !important;
    color: #555 !important;
    margin: 0 0 12px 0 !important;
`;

const TestimonialDate = styled(Text)`
    font-size: 0.8125rem !important;
    color: #999 !important;
    font-style: italic;
    margin: 0 !important;
    align-self: flex-start;
`;
